import React, { useEffect, useState } from "react";
import client, { mediaUrl } from "../lib/api";
import Layout, { PageHero } from "../components/site/Layout";
import { EmptyState } from "../components/site/common";
import { Newspaper } from "lucide-react";

function List({ items, testid }) {
  return (
    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
      {items.map((n) => (
        <article key={n.id} className="border border-gold/20 bg-white" data-testid={`${testid}-${n.id}`}>
          {n.image && <div className="aspect-video overflow-hidden bg-ivory"><img src={mediaUrl(n.image)} alt={n.title} className="h-full w-full object-cover" /></div>}
          <div className="p-7">
            <div className="flex items-center gap-3 text-xs text-ink-muted">
              {n.category && <span className="text-gold-dark">{n.category}</span>}
              {n.date && <span>· {n.date}</span>}
            </div>
            <h3 className="mt-2 text-xl font-medium text-maroon">{n.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted">{n.summary}</p>
          </div>
        </article>
      ))}
    </div>
  );
}

export default function News() {
  const [news, setNews] = useState([]);
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    Promise.all([
      client.get("/public/news").then(({ data }) => setNews(data)).catch(() => {}),
      client.get("/public/events").then(({ data }) => setEvents(data)).catch(() => {}),
    ]).finally(() => setLoaded(true));
  }, []);

  const empty = loaded && news.length === 0 && events.length === 0;

  return (
    <Layout>
      <PageHero eyebrow="News & Events" title="Updates from the Trust." intro="News and updates from Sri Akilandeswari Amman Trust will be published here." />
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24 space-y-16">
        {empty ? (
          <EmptyState icon={Newspaper} title="No news or events yet" message="News and updates from Sri Akilandeswari Amman Trust will be published here." />
        ) : (
          <>
            {news.length > 0 && <div><h2 className="mb-8 text-2xl font-medium text-maroon">Latest News</h2><List items={news} testid="news" /></div>}
            {events.length > 0 && <div><h2 className="mb-8 text-2xl font-medium text-maroon">Events</h2><List items={events} testid="event" /></div>}
          </>
        )}
      </section>
    </Layout>
  );
}
